import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

// const MY_ICONS = {
//   'ic-calendar': '<path d="M32.333 43.3v9.4H21.89v-9.4h10.444Zm20.89 0v9.4H42.777v-9.4h10.444Zm20.888 0v9.4H63.667v-9.4H74.11Zm10.445-32.9c2.77 0 5.426.99 7.385 2.753C93.9 14.916 95 17.307 95 19.8v65.8c0 2.493-1.1 4.884-3.06 6.647C89.983 94.01 87.327 95 84.557 95H11.444C5.648 95 1 90.77 1 85.6V19.8c0-2.493 1.1-4.884 3.06-6.647C6.017 11.39 8.673 10.4 11.443 10.4h5.223V1H27.11v9.4h41.78V1h10.444v9.4h5.223Zm0 75.2V33.9H11.444v51.7h73.112ZM32.333 62.1v9.4H21.89v-9.4h10.444Zm20.89 0v9.4H42.777v-9.4h10.444Zm20.888 0v9.4H63.667v-9.4H74.11Z"/>'
// }

import IconCalendar from '@/components/icons/IconCalendar.vue'
import IconOutlineMinus from '@/components/icons/IconOutlineMinus.vue'
import IconOutlinePlus from '@/components/icons/IconOutlinePlus.vue'
import IconCross from '@/components/icons/IconCross.vue'

Vue.use(Vuetify);

let themeColors = {
  primary: '#248983',
  accent: '#248983',
  // primary: '#17b0e1',
  // accent: '#17b0e1'
}
if(process.env.VUE_APP_THEME === 'yar') {
  themeColors = {
    primary: '#01adc9',
    accent: '#01adc9',
  }
}

export default new Vuetify({
  icons: {
    values: {
      calendar: { component: IconCalendar, },
      outlineMinus: {component: IconOutlineMinus},
      outlinePlus: {component: IconOutlinePlus},
      cross: {component: IconCross},
    },
  },

  theme: {
    themes: {
      light: themeColors,
    },
  },
});
